import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { addOrUpdateItem, getSTOrderPreview, resetSTOrderResultBox, setSTOrderDescription, setSTOrderMatrixRenderOff, setSTOrderResultBox, submitSTOrder } from '../slices/storder.slice';
import { GroupBy, Transpose, ValidateSTOrder } from '../helpers/mmg';
import uuid from 'react-uuid';
import TextField from '@mui/material/TextField';
import { useEffect, useRef ,useState } from 'react';
import { useMemo } from 'react';
import { setInvoiceError } from '../slices/invoices.slice';
import { addItemsFromMatrix, deleteAllMatrix, deleteAllMatrixAndSubmitDirectly, submitOrderAfterCloseMatrix } from '../slices/matrix.slice';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Tooltip from '@mui/material/Tooltip';
import BeenhereIcon from '@mui/icons-material/Beenhere';

export const zeroPad = (num, places) => String(num).padStart(places, '0');


const mdTheme = createTheme({

  typography: {
    fontFamily: [
      "mohammadfont",
      "Tahoma",
      "Verdana"
    ].join(",")
  },
  
  direction: 'ltr',
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#FBC02D',
          color: '#424242'
        },
      },
    },
  }
});


export const MatrixQuantity = () => {
  

  const [open, setOpen] = React.useState(false);
  //const [quantity, setQuantity] = React.useState(false);

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const stOrder = useSelector(x => x.stOrder);
  //const matrix = useSelector(x => x.matrix.itemsToAddFromMatrix);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();
 
  const handleSaveMatrix = () =>{

    //dispatch(setSTOrderCloseMatrix());
    navigate('/st');

  }

  const handleCloseMatrix = () =>{

    dispatch(deleteAllMatrix());
    //dispatch(setSTOrderCloseMatrix());
    navigate('/st');

  }
  const handleYes = () => {
    setOpen(false);
    
    //dispatch(submitOrderAfterCloseMatrix());
    navigate('/st');

  };
  const handleDescriptionChange = (e) =>{

    dispatch(setSTOrderDescription(e.target.value));
  
  }
  const handleCloseMessageBox = () =>{
    dispatch(resetSTOrderResultBox());
    //navigate('/ST');
  }
 
   const handleDirectSubmitOrder = () =>{
    //setOpen(true);
    navigate('/st');
   }
  const handleClose = () => {
    setOpen(false);
  };
  const handleNo = () => {
    setOpen(false);
  };
  var gL = {};
  var rowsPositive = [];
  var rowsNegative = [];

if(stOrder.matrix !== undefined && stOrder.matrix !== null && stOrder.matrix.length > 0){
    console.log("Render");
    var cylArray = [];
    console.log("Start Transpose");
    gL = Transpose(stOrder.matrix);
    console.log("End Transpose");
    var cylArrayEtZ = [ "0.00" ];
    var cylArrayEtc = [...new Set(gL["CYL"])].map((item) => {
      if(parseFloat(item) !== 0){
        return parseFloat(item).toFixed(2);
      }
    }).filter(function( element ) {
      return element !== undefined;
    }).sort();
    cylArray = cylArrayEtZ.concat(cylArrayEtc);

    var rowPos = [];
    var rowNeg = [];
    var rowsCYL = [];
    rowPos.push(<tr><td colSpan={cylArray.length + 1}><Typography className='matrixHeaderRow'>
    {stOrder.selectedLensBrandId > 0 ? stOrder.lensbrands.find(r => r.Value.toString() == stOrder.selectedLensBrandId.toString()).Name : ''}
    -
    {stOrder.selectedLensTypeId > 0 ? stOrder.lensTypes.find(r => r.Value.toString() == stOrder.selectedLensTypeId.toString()).Name : ''}
    -
    {stOrder.selectedLensIndexId > 0 ? stOrder.lensIndexes.find(r => r.Value.toString() == stOrder.selectedLensIndexId.toString()).Name : ''}
    <span>(+.-)</span>
    </Typography></td></tr>)
    rowNeg.push(<tr><td colSpan={cylArray.length + 1}><Typography  className='matrixHeaderRow'>
    {stOrder.selectedLensBrandId > 0 ? stOrder.lensbrands.find(r => r.Value.toString() == stOrder.selectedLensBrandId.toString()).Name : ''}
    -
    {stOrder.selectedLensTypeId > 0 ? stOrder.lensTypes.find(r => r.Value.toString() == stOrder.selectedLensTypeId.toString()).Name : ''}
    -
    {stOrder.selectedLensIndexId > 0 ? stOrder.lensIndexes.find(r => r.Value.toString() == stOrder.selectedLensIndexId.toString()).Name : ''}
    <span>(-.-)</span>
    </Typography></td></tr>)
    rowsCYL.push(<th key={uuid()} className='matrixQuantityBGTitle'>&nbsp;SPH/CYL&nbsp;</th>);
    for(var y = 0 ; y < cylArray.length ; y++){
      rowsCYL.push(<th key={uuid()} className='matrixQuantityBG'>{cylArray[y]}</th>);
    }

    //rowsNegative.push(<tr>{rowsCYL}</tr>);
    //rowsPositive.push(<tr>{rowsCYL}</tr>);

    var sphArrayGtZ = [...new Set(gL["SPH"])].map((item) => {
      if(parseFloat(item) > 0){
        return parseFloat(item).toFixed(2);
      }
    }).filter(function( element ) {
      return element !== undefined;
    });//.sort();
    var sphArrayEtZ = [ "0.00" ];
    var sphArrayLtZ = [...new Set(gL["SPH"])].map((item) => {
      if(parseFloat(item) < 0){
        return parseFloat(item).toFixed(2);
      }
    }).filter(function( element ) {
      return element !== undefined;
    });//.sort();
    
    console.log(cylArray);
    //sphArray = sphArrayEtZ.concat(sphArrayLtZ, sphArrayGtZ);
    var sphArrayNegative = (sphArrayEtZ.concat(sphArrayLtZ)).sort((a, b) => parseFloat(b) - parseFloat(a));
    console.log(sphArrayNegative);

    for(var y = 0 ; y < sphArrayNegative.length ; y++){
      var rowsSPH = [];
      if(sphArrayNegative[y] !== undefined){
      rowsSPH.push(<td key={uuid()} className='matrixQuantityBG'>{sphArrayNegative[y]}</td>);
      for(var x = 0 ; x < cylArray.length ; x++){
        if(stOrder.matrix.find(p => parseFloat(p.SPH).toFixed(2) === sphArrayNegative[y] && parseFloat(p.CYL).toFixed(2) === cylArray[x])){
          var foundProduct = stOrder.matrix.find(p => parseFloat(p.SPH).toFixed(2) === sphArrayNegative[y] && parseFloat(p.CYL).toFixed(2) === cylArray[x]);
          rowsSPH.push(<td key={uuid()}>
            <input type='number' key={uuid()} min="0" max="30"
            id={foundProduct.Fee + ";" +foundProduct.ProductCode+ ";" + foundProduct.ProductTitle + ";" + foundProduct.ProductId} 
            onChange={(e) => handleRowValueChange(e)} disabled={foundProduct.Quantity <= 0}
            className={(foundProduct.Quantity > 0 ? 'matrixQuantityInput' : 'matrixQuantityInputDisabled')}/>
            </td>);
        }else{
          rowsSPH.push(<td key={uuid()}>
           <input type='number' key={uuid()} min="0" max="30"
            disabled={true}
            //onChange={(e) => handleRowValueChange(e)} disabled={foundProduct.Quantity <= 0}
            className='matrixQuantityInputDisabled'
            />
        
          </td>);
        }
      }
      }
      rowsNegative.push(<tr>{rowsSPH}</tr>);
    }

    var sphArrayPositive = sphArrayGtZ.sort((a, b) => parseFloat(a) - parseFloat(b));
    for(var y = 0 ; y < sphArrayPositive.length ; y++){
      var rowsSPH = [];
      //console.log("HHH");
      //console.log(sphArrayPositive[y]);
      if(sphArrayPositive[y] !== undefined){
      rowsSPH.push(<td key={uuid()} className='matrixQuantityBG'>+{sphArrayPositive[y]}</td>);
      for(var x = 0 ; x < cylArray.length ; x++){
        if(stOrder.matrix.find(p => parseFloat(p.SPH).toFixed(2) === sphArrayPositive[y] && parseFloat(p.CYL).toFixed(2) === cylArray[x])){
          var foundProduct = stOrder.matrix.find(p => parseFloat(p.SPH).toFixed(2) === sphArrayPositive[y] && parseFloat(p.CYL).toFixed(2) === cylArray[x]);
          rowsSPH.push(<td key={uuid()}>
            <input type='number' key={uuid()} min="0" max="30"
            id={foundProduct.Fee + ";" +foundProduct.ProductCode+ ";" + foundProduct.ProductTitle + ";" + foundProduct.ProductId} 
            onChange={(e) => handleRowValueChange(e)} disabled={foundProduct.Quantity <= 0}
            className={(foundProduct.Quantity > 0 ? 'matrixQuantityInput' : 'matrixQuantityInputDisabled')}/>
            </td>);
          //console.log("CYL : " +cylArray[x]);
          //console.log(stOrder.matrix.find(p => p.SPH === sphArray[y] && p.CYL === cylArray[x]));
        }else{
          rowsSPH.push(<td key={uuid()}>
          <input type='number' key={uuid()} min="0" max="30"
             disabled={true}
            //onChange={(e) => handleRowValueChange(e)} disabled={foundProduct.Quantity <= 0}
            className='matrixQuantityInputDisabled'/>
          </td>);
        }
      }
    }
      rowsPositive.push(<tr>{rowsSPH}</tr>);
    }
 }
const handleRowValueChange = (e) => {

  console.log("Item Changed");
  console.log(e);
  console.log(e.target.id);
  console.log(e.target.id.toString().split(';'));
  
  var selectedQuantity = e.target.value;
  var selectedProductFee = e.target.id.toString().split(';')[0];
  var selectedProductCode = e.target.id.toString().split(';')[1];
  var selectedProductTitle = e.target.id.toString().split(';')[2];
  var selectedProductId = e.target.id.toString().split(';')[3];

  console.log("selectedQuantity : " + selectedQuantity);
  console.log("selectedProductCode : " + selectedProductCode);
  console.log("selectedProductTitle : " + selectedProductTitle);
  console.log("selectedProductId : " + selectedProductId);
  console.log("selectedFee : " + selectedProductFee);

  const input = document.getElementById(e.target.id);
  input.classList.add("matrixQuantityInputWithData");

  dispatch(addItemsFromMatrix({selectedRowId : 0 , selectedProductId : selectedProductId , selectedProductCode : selectedProductCode, selectedProductTitle : selectedProductTitle , selectedQuantity : selectedQuantity , selectedFee : selectedProductFee , addQuantityToCurrent : true , authUser}));

};

return (

<ThemeProvider theme={mdTheme}>
    {stOrder.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div> :
      <div>
          <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleSaveMatrix}
              aria-label="close"
            >
              {/*<SaveIcon />*/}
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              {/*ذخیره  */}
            </Typography>

            <Typography style={{ textAlign : 'center' , fontSize : '20px' }} align="center">
            {stOrder.selectedLensBrandId > 0 ? stOrder.lensbrands.find(r => r.Value.toString() == stOrder.selectedLensBrandId.toString()).Name : ''}
            -
            {stOrder.selectedLensTypeId > 0 ? stOrder.lensTypes.find(r => r.Value.toString() == stOrder.selectedLensTypeId.toString()).Name : ''}
            -
            {stOrder.selectedLensIndexId > 0 ? stOrder.lensIndexes.find(r => r.Value.toString() == stOrder.selectedLensIndexId.toString()).Name : ''}
            </Typography>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button autoFocus color="inherit" onClick={handleCloseMatrix}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            </Button>
          </Toolbar>
          </AppBar>
            <table className='matrixQuantity'>
            <thead>
            {rowsCYL}
            </thead>
            <tbody>
            {rowNeg}
            {rowsNegative}
            {rowPos}
            {rowsPositive}
            </tbody>
            </table>
      

<Box sx={{ flexGrow: 1 }} style={{position: 'fixed' , bottom : '0'}}>
     
     <Grid container>
              <Grid item xs={12}>
                        <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-footer"
                >
                </AccordionSummary>
                <AccordionDetails >
                <Box textAlign='center'>
                <TextField
                  id="standard-multiline-static"
                  label="توضیحات"
                  fullWidth="true"
                  variant="standard"
                  value={stOrder.description}
                
                  onChange={evt => handleDescriptionChange(evt)}
                />
           <Tooltip title="اضافه به سفارش">
           <Button 
           //disabled={quantity <= 0} 
           color="success" onClick={handleDirectSubmitOrder} variant="outlined" startIcon={<BeenhereIcon />}>
                    اضافه به سفارش
                 </Button>
           </Tooltip>  </Box>
                </AccordionDetails>
              
          </Accordion>
             </Grid>
     </Grid>
     </Box></div>
         }
         <Dialog
              open={stOrder.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={stOrder.boxType === 1 ? "error" : (stOrder.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: stOrder.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleCloseMessageBox}>
                خب
              </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
              </DialogActions>
            </Dialog>
    </ThemeProvider>

  );
}

export default MatrixQuantity;